import { CompanyWithCollaboratives } from "../../../types/company/company";
import { CompanyWithCollaborativesDto } from "../../../types/company/company-dto";
import { convertCompanyWithCollaborativesDtoToCompanyWithCollaboratives } from "../../../utils/converter/user/company-with-collaboratives-convertor";
import { CompanyState } from "../../type/company-state";
interface Action {
  type: string;
  payload: {
    companyWithCollaborativesDto: CompanyWithCollaborativesDto;
  };
}

export const setCompanyWithCollaborativesInPageByDtoDispatch = (
  state: CompanyState,
  action: Action
) => {
  const { companyWithCollaborativesDto } = action.payload;

  const newCompanyWithCollaboratives =
    convertCompanyWithCollaborativesDtoToCompanyWithCollaboratives(
      companyWithCollaborativesDto
    );

  const index = state.companyWithCollaborativesPage.contents.findIndex(
    (companyWithCollaboratives: CompanyWithCollaboratives) => {
      return companyWithCollaboratives.id === newCompanyWithCollaboratives.id;
    }
  );

  if (index !== -1) {
    state.companyWithCollaborativesPage.contents[index] =
      newCompanyWithCollaboratives;
  } else {
    state.companyWithCollaborativesPage = {
      ...state.companyWithCollaborativesPage,
      contents: [
        newCompanyWithCollaboratives,
        ...state.companyWithCollaborativesPage.contents.slice(0, 9),
      ],
    };
  }
};
